// NPM
import React from "react"

// Shared Components
import Partners from "src/components/Shared/Partners"

// Contact Components
import Hero from "./Hero"
import ContactForm from "./ContactForm"
import Testimonials from "./Testimonials"

const Contact = ({ sections, contactForm, testimonials }) => {
  return (
    <div className="Contact">
      <Hero section={sections.find(s => s.uuid === "contactUs_title")} />

      <div className="columns">
        <div className="column is-6">
          <ContactForm
            contactForm={contactForm}
            contactFormSection={sections.find(s => s.uuid === "contactUs_form")}
          />
        </div>
        <div className="column is-5 is-offset-1">
          <Partners
            section={sections.find(s => s.uuid === "partners")}
            slidesToShow={2}
          />
          <Testimonials
            section={sections.find(s => s.uuid === "testimonials")}
            testimonials={testimonials}
          />
        </div>
      </div>
    </div>
  )
}

export default Contact
